import { DrawerBase } from '../core/abstraction/DrawerBase';
import { gameConfig, gameMobileConfig } from '../core/configs';
import { GAME_MODE } from '../stateManagment/gameState';
import { FONT_BALOO_NAME, FONT_LATO_NAME, GAME_MODES } from '../core/constats';
import { gameLandscapeDrawer } from './drawers/GameLandscapeDrawer';
import { gameDesktopDrawer } from './drawers/GameDesktopDrawer';
import { gameMobileDrawer } from './drawers/GameMobileDrawer';
import { sharedResources } from '../core/gameConstants';
import { setupWebFontConfig } from '../core/helpers/setupWebFontConfig';
import { defaultTranslation } from '../core/translation/translation';

class GameDrawer extends DrawerBase {
  translations = defaultTranslation
  constructor(applications) {
    super();
    this.applications = applications;
    this.mobile = this.createApplication(gameMobileConfig.config);
    this.mobile_landscape = this.createApplication(gameConfig.config);
    this.desktop = this.createApplication(gameConfig.config);
    this.loader = this.createLoader();
    this.resources = null;
    window.__PIXI_APP__ = this.desktop
    console.log(this.mobile ,this.desktop )
    this.applications[GAME_MODES.MOBILE].defineParent(this.mobile.stage);
    this.applications[GAME_MODES.DESKTOP].defineParent(this.desktop.stage);
    this.fontLoaded = false;
  }

  get parent() {
    const gameMode = GAME_MODE.getValue();
    switch (gameMode) {
      case GAME_MODES.DESKTOP:
        console.log(1)
        return this.desktop;
      case GAME_MODES.MOBILE_LANDSCAPE:
        console.log(2)
        return this.mobile_landscape;
      case GAME_MODES.MOBILE:
        console.log(3)
        return this.mobile;
      default:
        return this.desktop = this.createApplication(gameConfig.config);
    }
  }

  async loadResource() {
    if (!this.resources) {
      const { res } = super.loadResource(sharedResources, this.loader);
      this.resources = res;
    }
    return this.resources;
  }

  async loadFonts() {
    if (this.fontLoaded) {
      return this.fontLoaded;
    }

    return new Promise((resolve) => {
      window.WebFontConfig = {
        google: {
          families: [`${FONT_BALOO_NAME}:700`, `${FONT_LATO_NAME}`],
        },
        active() {
          resolve(true);
        },
      };
      setupWebFontConfig();
    });
  }

  getApplication(mode) {
    return this.applications[mode];
  }

  execute(root) {
    this.loadResource().then(() => {
      root.appendChild(this.parent.view);
    });
  }

  modeChange({ mode, scene, prevScene }) {
    this.loadFonts().then(() => {
      this.fontLoaded = true;
      this.applications[mode].execute({ scene, parent: this.parent.stage, prevScene });
    });
  }
}

export const gameDrawer = new GameDrawer({
  [GAME_MODES.MOBILE_LANDSCAPE]: gameLandscapeDrawer,
  [GAME_MODES.DESKTOP]: gameDesktopDrawer,
  [GAME_MODES.MOBILE]: gameMobileDrawer,
});
